import { useAuthContext } from '../context/AuthContext';

/**
 * useAuth — convenience hook that exposes the full AuthContext value.
 *
 * Usage:
 *   const { user, isAuthenticated, login, logout, register } = useAuth();
 */
export function useAuth() {
  return useAuthContext();
}

export default useAuth;
